import { decodeEntities } from "@wordpress/html-entities";
import { Observer } from "mobx-react-lite";
import React from 'react';
import joinClassName from "../../../utils/className.utils";
import { useProps, useStore } from "../../../utils/mobx.utils";
import { getTagColor } from "./PostResultItem";
import './TagResultItem.scss';
var TagResultItem = function (props) {
    var p = useProps(props);
    var s = useStore(function () { return ({
        get tag() {
            return p.result;
        },
        get tagName() {
            var _a;
            return (_a = s.tag.name) !== null && _a !== void 0 ? _a : "";
        }
    }); });
    return React.createElement(Observer, { children: function () { return (React.createElement(React.Fragment, null,
            React.createElement("li", { className: joinClassName("TagResultItem") },
                React.createElement("a", { className: joinClassName("TagResultsItemLink", "related-tags__card", "SearchItemColorable", getTagColor(s.tagName)), href: s.tag.link },
                    React.createElement("div", { className: "related-tag__name" }, decodeEntities(s.tagName)),
                    React.createElement("div", { className: "related-tag__extra" }, "View Articles"))))); } });
};
export default TagResultItem;
